(() => {
  const TOAST_SELECTOR = '[data-theme-toast]';
  const DEFAULT_DURATION = 1500;
  const DRAWER_DURATION = 750;

  class ThemeToast {
    constructor(element) {
      this.element = element;
      this.title = element.querySelector('[data-theme-toast-title]');
      this.message = element.querySelector('[data-theme-toast-message]');
      this.action = element.querySelector('[data-theme-toast-action]');
      this.closeButton = element.querySelector('[data-theme-toast-close]');
      this.timeout = null;

      this.closeButton?.addEventListener('click', () => this.hide());
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.element.hidden) this.hide();
      });
    }

    show(options = {}) {
      const {
        type = 'success',
        title = '',
        message = '',
        actionText = '',
        actionUrl = '',
        duration = DEFAULT_DURATION,
      } = options;
      const drawerIsOpen =
        document.querySelector('cart-drawer.active') ||
        document.querySelector('wishlist-drawer.active');
      const toastDuration = drawerIsOpen && type !== 'error' ? DRAWER_DURATION : duration;

      window.clearTimeout(this.timeout);

      this.element.dataset.toastType = type;
      this.title.textContent = title;

      this.message.textContent = message;
      this.message.hidden = !message;

      this.action.textContent = actionText;
      this.action.href = actionUrl || '#';
      this.action.hidden = !actionText || !actionUrl;

      this.element.hidden = false;
      this.element.setAttribute('role', type === 'error' ? 'alert' : 'status');

      requestAnimationFrame(() => {
        this.element.classList.add('is-visible');
      });

      if (toastDuration > 0) {
        this.timeout = window.setTimeout(() => this.hide(), toastDuration);
      }
    }

    hide() {
      window.clearTimeout(this.timeout);
      this.element.classList.remove('is-visible');

      window.setTimeout(() => {
        if (!this.element.classList.contains('is-visible')) {
          this.element.hidden = true;
        }
      }, 220);
    }
  }

  const init = () => {
    const element = document.querySelector(TOAST_SELECTOR);
    if (!element || window.themeToast) return;

    const toast = new ThemeToast(element);
    window.themeToast = {
      show: toast.show.bind(toast),
      hide: toast.hide.bind(toast),
    };

    document.addEventListener('theme-toast:show', (event) => {
      toast.show(event.detail || {});
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
